import DrawerMenuLinks from './drawer-menu-links';

export default DrawerMenuLinks;
